<template>
  <div>
    <b-modal
      id="sesToTrainee"
      size="md"
      title="Get data from Ses"
      ref="sesToTrainee"
    >
      <div class="form-row">
        <div class="col">
          <label for="mouza">Mouza <span class="c-required">*</span></label>
          <select
            v-model="sesToTrainee.c_mouza_id"
            v-validate="'required'"
            id="mouza" name="mouza"
            class="form-control form-control-sm"
          >
            <option selected>Select a mouza</option>
            <option
              v-for="(mouza, index) in mouzas"
              :key="index"
              :value="mouza.id"
              >{{ mouza.id }} : {{ mouza.desc }}</option
            >
          </select>
        </div>
        <div class="col">
          <label for="type">Select Search type</label>
          <select
            :disabled="!sesToTrainee.c_mouza_id"
            v-model="sesToTrainee.type"
            name="type" id="type"
            class="form-control form-control-sm"
          >
            <option value="nid">NID/Passport/Birth Reg.</option>
            <option value="hid">Household No.</option>
          </select>
        </div>
      </div>

      <div class="form-row mt-2">
        <div class="col">
          <div class="form-group">
            <label for="value">Enter number</label>
            <input type="number" v-model="sesToTrainee.value" id="value" name="value"
                    :disabled="!sesToTrainee.type"
                    class="form-control form-control-sm"
            />
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-button
          size="md"
          class="float-right mx-4"
          variant="success"
          @click="getData"
          >Get Data</b-button
        >
        &nbsp;&nbsp;
        <b-button
          size="md"
          class="float-right"
          variant="danger"
          @click="hideModal"
          >Close</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";

export default {
  props: ["mouzas"],
  data() {
    return {
      sesToTrainee: {
        c_mouza_id: "",
        type: "",
        value: ""
      },

      validateError: "",
      swalOptions: {
        type: "error",
        title: "Oops...",
        text: "You do not have the right permissions",
        confirmButtonColor: "#ff7674"
      }
    };
  },

  mounted() {},
  methods: {
    getData() {
      http
        .post("api/trainee/SesToTrainee", this.sesToTrainee)
        .then(response => {
          if (!response.error) {
            this.$emit("getSesToTrainee", response.data);
          }
        });
    },

    hideModal() {
      this.$refs.sesToTrainee.hide();
    }
  }
};
</script>
<style>
  .c-required{
    color: red;
  }
</style>
